import React from 'react';
import HintWithIcon from '@bonprix/pattern-library/templates/hint/with-icon';

// TODO: show als prop entfernen und nur text haben! show muss in der jeweiligen komponente liegen!
export default function ErrorMessageBanner({text, show}) {
    return (
        show && (
            <HintWithIcon className="checkout-error-message-banner" icon="error">
                <p dangerouslySetInnerHTML={{__html: text}} />
            </HintWithIcon>
        )
    );
}
